import { createFileRoute, Link } from "@tanstack/react-router";
import { Search, ShieldCheck, Users, TrendingUp } from "lucide-react";

export const Route = createFileRoute("/lexpractiq/for-employers")({
  head: () => ({
    meta: [
      { title: "For Employers & Law Firms | SA LexPractiq" },
      { name: "description", content: "Discover verified legal talent by demonstrated skill. Review portfolios, run custom assessments and invite interviews." },
      { property: "og:title", content: "For Employers — SA LexPractiq" },
      { property: "og:description", content: "Hire on skill, not just CVs. Verified simulations. Real work samples." },
    ],
  }),
  component: ForEmployersPage,
});

function ForEmployersPage() {
  return (
    <div className="lxp-container" style={{ padding: "3rem 1.25rem", maxWidth: 1000 }}>
      <span className="lxp-badge">For Employers &amp; Law Firms</span>
      <h1 style={{ fontSize: "clamp(1.8rem, 4vw, 2.6rem)", margin: "0.5rem 0 1rem", letterSpacing: "-0.02em" }}>
        Hire on <span style={{ color: "var(--lxp-accent)" }}>demonstrated skill</span>, not just CVs
      </h1>
      <p className="lxp-muted" style={{ fontSize: "1.05rem", lineHeight: 1.65, marginBottom: "2rem", maxWidth: 720 }}>
        Every candidate on SA LexPractiq comes with verified work samples, rubric scores across five legal competencies,
        and certificates you can authenticate in one click.
      </p>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: "1rem", marginBottom: "2rem" }}>
        {[
          { icon: <Search size={22} />, t: "Candidate search", d: "Filter by simulation, score threshold, practice area, university and location." },
          { icon: <Users size={22} />, t: "Portfolio review", d: "Read real drafts — intake notes, memos, letters of demand, contracts." },
          { icon: <ShieldCheck size={22} />, t: "Verified certificates", d: "Every certificate carries a QR verification URL you can check in seconds." },
          { icon: <TrendingUp size={22} />, t: "Custom assessments", d: "Send a simulation as a screening step and see how candidates actually think." },
        ].map((f) => (
          <div key={f.t} className="lxp-card">
            <div style={{
              width: 42, height: 42, borderRadius: 10, background: "var(--lxp-accent-glow)",
              color: "var(--lxp-accent)", display: "grid", placeItems: "center", marginBottom: "0.75rem",
            }}>{f.icon}</div>
            <h3 style={{ margin: "0 0 0.4rem", fontSize: "1.05rem" }}>{f.t}</h3>
            <p className="lxp-muted" style={{ margin: 0, fontSize: "0.9rem" }}>{f.d}</p>
          </div>
        ))}
      </div>

      <div className="lxp-card" style={{ textAlign: "center", padding: "2rem" }}>
        <h2 style={{ margin: "0 0 0.5rem" }}>Get recruiter access</h2>
        <p className="lxp-muted" style={{ margin: "0 0 1.25rem" }}>Sign in and request the Recruiter role to unlock the candidate search dashboard.</p>
        <Link to="/auth" search={{ portal: "lxp", redirect: "/lexpractiq/dashboard", mode: "signup" } as any} className="lxp-btn">Sign in / create account</Link>
      </div>
    </div>
  );
}
